import getUserMedia from "./getUserMedia"
import enumerateDevices from "./enumerateDevices"

export default {
    getUserMedia,
    enumerateDevices
}